import { atom } from 'recoil';

export const openJobtitleEditModalAtom = atom<number | null>({
	key: 'openJobtitleEditModal',
	default: null,
});
